import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/loading
 * @param {String} type - type for sucess/error/loading
 */

export const categorySuccess = (
  payload = {},
  type = types.CATEGORY_SUCCESS
) => {
  return {
    type,
    payload
  };
};

export const categoryLoading = (
  payload = {},
  type = types.CATEGORY_LOADING
) => {
  return {
    type,
    payload
  };
};
